import {Eye, Pen, Trash2} from "lucide-react";
import {Button} from "@/components/ui/button.tsx";
import DeleteConfirm from "@/components/forms/DeleteConfirm.tsx";
import AuditMetadata from "@/components/management/AuditMetadata.tsx";
import SpellDetails from "@/spells/SpellDetails.tsx";
import {Spell} from "@/spells/model/Spell.ts";

export default function SpellDetail({spell, onDisplay, onEdit, onDelete}: {
    spell: Spell;
    onDisplay: () => void;
    onEdit: () => void;
    onDelete: () => Promise<void>;
}) {
    return (
        <article className="flex size-full min-h-0 flex-col gap-3">
            <title>{`${spell.name} | DireDawn`}</title>
            <header className="flex shrink-0 flex-wrap items-start justify-between gap-3">
                <div className="flex flex-wrap items-center justify-end gap-2">
                    <Button variant="outline" size="sm" onClick={onDisplay}><Eye/> Anzeigen</Button>
                    <Button variant="outline" size="sm" onClick={onEdit}><Pen/> Bearbeiten</Button>
                </div>
                <div className="flex flex-wrap items-center gap-2">
                    <AuditMetadata createdAt={spell.createdAt} updatedAt={spell.updatedAt}/>
                    <DeleteConfirm title={`${spell.name} global löschen?`}
                                   description="Der Zauber wird aus dem globalen Katalog und aus allen Zauberlisten von Charakteren entfernt. Diese Aktion kann nicht rückgängig gemacht werden."
                                   onConfirm={onDelete}>
                        <Button size="icon-sm" variant="destructive" title="Löschen"
                                onSelect={event => event.preventDefault()}><Trash2/></Button>
                    </DeleteConfirm>
                </div>
            </header>
            <div className="min-h-0 flex-1 overflow-auto"><SpellDetails spell={spell}/></div>
        </article>
    );
}
